<template>
  <v-navigation-drawer
    ref="drawer"
    v-model="openSidebar"
    width="460"
    app
    absolute
    temporary
    stateless
    right
  >
    <template #prepend>
      <v-list-item two-line>
        <v-list-item-avatar class="my-0 mr-1">
          <v-icon dense>far fa-folder-upload</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            Dateien <small class="grey--text">({{room.name}})</small>
          </v-list-item-title>
        </v-list-item-content>

        <v-btn icon @click="_back">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>
    </template>

    <section
      class="d-flex flex-column"
      @drop.prevent="_onDrop"
      @keydown.esc="_back"
    >
      <FilesUpload
        ref="upload"
        :class="{
          'flex-grow-0': listVisible
        }"
        :dense="listVisible"
        :quota-free="quota_free"
      />

      <v-divider v-show="listVisible"></v-divider>
      <FilesList
        ref="filesList"
        :page="page"
        @visible="listVisible = $event"
        @quota-free="quota_free = $event"
      />
    </section>
  </v-navigation-drawer>
</template>

<script>
  import RouteDialogMixin from './dialogs/RouteDialogMixin';
  import FilesUpload from './files/FilesUpload';
  import FilesList from './files/FilesList';
  import eventBus from '../assets/js/event-bus';
  import {routeOptions} from '../assets/js/utils';


  export default {
    name: 'ShareFiles',

    components: {
      FilesUpload,
      FilesList
    },

    mixins: [
      RouteDialogMixin
    ],

    data() {
      return {
        openSidebar: false,
        updating: null,
        listVisible: false,
        quota_free: 0,
        // RouteDialogMixin
        routePath: '/share/files'
      };
    },

    computed: {
      room() {
        return this.$store.getters['share/getRoom'];
      },

      page() {
        return parseInt(this.$route.query.page) || 1;
      }
    },

    watch: {
      openSidebar(openSidebar) {
        if (openSidebar) {
          this.loadFiles();

          // Go back / close drawer if clicked outside.
          this.$nextTick(() => {
            const drawerParent = this.$refs.drawer.$el.parentNode;
            const overlay = [...drawerParent.childNodes].find((child) => child.matches('.v-overlay'));
            overlay.addEventListener('click', () => this._back());
          });
        }
      },

      page() {
        if (this.openSidebar) {
          try {
            this.$nextTick(async () => this.loadFiles());
          } catch (error) {
            /* NOOP */
          }
        }
      }
    },

    mounted() {
      eventBus.$on('roomFilesChanged', this._onRoomFilesChanged);
      eventBus.$on('filesSelect', this._onSelectFiles);
      this.$options.watch.openSidebar[0].call(this, this.openSidebar);
    },

    destroyed() {
      eventBus.$off('roomFilesChanged', this._onRoomFilesChanged);
      eventBus.$off('filesSelect', this._onSelectFiles);
    },

    methods: {
      show() {
        if (this.room.id === 'local') {
          return this.$router.replace(routeOptions({path: '/share'}));
        }
        this.openSidebar = true;
      },

      hide() {
        this.openSidebar = false;
      },

      toggle() {
        this.openSidebar = !this.openSidebar;
      },

      loadFiles(opt_noLoadingAnimation) {
        this.$refs.filesList.loadFiles(opt_noLoadingAnimation);
      },

      _back() {
        this.$router.replace(routeOptions({path: '/share'}));
      },

      async _onRoomFilesChanged({id: roomId}) {
        // If room not active, sidebar not opened or already updating.
        if (roomId !== this.room.id || !this.openSidebar || this.updating) {
          return;
        }
        const start = Date.now();
        const lockTime = 500;
        const NO_LOADING_ANIMATION = true;

        this.updating = this.loadFiles(NO_LOADING_ANIMATION);
        await this.updating;

        const time = Date.now() - start;
        if (time >= lockTime) {
          this.updating = null;
        } else {
          setTimeout(() => this.updating = null, time - lockTime);
        }
      },

      _onDrop(e) {
        const {upload} = this.$refs;
        upload.files = [...upload.files, ...e.dataTransfer.files];
      },

      _onSelectFiles(files) {
        const {upload} = this.$refs;
        upload.files = [...upload.files, ...files];
        this.$router.push(routeOptions({path: '/share/files'}));
      }
    }
  };
</script>

<style scoped>
  .v-navigation-drawer {
    position: fixed;
  }

  .v-list-item__subtitle {
    white-space: normal;
  }

  section {
    height: 100%;
  }
</style>
